<template>
  <div class="w-full relative">
    <div
      class="grid gap-x-12 gap-y-6 w-full"
      :class="{
        hidden: finishedForm,
        'lg:grid-cols-2': !showCol,
      }"
    >
      <div class="col-span-full">
        <h3 class="heading-basic font-platform text-los-blue-darkest">
          Schrijf mij in voor:
          <u>{{ typeName }}</u>
        </h3>
      </div>

      <div>
        <h4
          class="text-lg/8 md:text-xl/9 font-semibold text-los-blue-darkest mb-0"
        >
          Lesdagen:
        </h4>
        <ul class="text-lg/8 md:text-xl/9">
          <li class="" v-for="times in dates" :key="times.id">
            - <WorkshopTimes :times="times" />
          </li>
        </ul>

        <slot></slot>
      </div>

      <div>
        <form
          v-if="canApply && !finishedForm"
          @submit.prevent="onSubmitForm"
          @change="validationErrorMessage = ''"
          class="w-full grid grid-cols-8 gap-x-3 gap-y-6"
        >
          <div class="col-span-4">
            <label for="firstname" class="font-medium"
              >Voornaam <span class="text-los-pink-dark">*</span></label
            >
            <input
              v-model="form.firstname"
              type="text"
              id="firstname"
              name="firstname"
              class="w-full px-3 py-2 bg-transparent outline-none rounded-lg bg-white border-none"
            />
          </div>
          <div class="col-span-4">
            <label for="lastname" class="font-medium"
              >Achternaam <span class="text-los-pink-dark">*</span></label
            >
            <input
              v-model="form.lastname"
              type="text"
              id="lastname"
              name="lastname"
              class="w-full px-3 py-2 bg-transparent outline-none rounded-lg bg-white border-none"
            />
          </div>
          <div class="col-span-full">
            <label for="email" class="font-medium"
              >E-mailadres <span class="text-los-pink-dark">*</span></label
            >
            <input
              v-model="form.email"
              type="text"
              id="email"
              name="email"
              class="w-full px-3 py-2 bg-transparent outline-none rounded-lg bg-white border-none"
            />
          </div>
          <div class="col-span-full">
            <label for="repeat" class="font-medium"
              >Herhaal e-mailadres
              <span class="text-los-pink-dark">*</span></label
            >
            <input
              v-model="form.repeat"
              type="text"
              id="repeat"
              name="repeat"
              class="w-full px-3 py-2 bg-transparent outline-none rounded-lg bg-white border-none"
            />
          </div>
          <div class="col-span-4">
            <label for="telephone" class="font-medium"
              >Telefoonnr. <span class="text-los-pink-dark">*</span></label
            >
            <input
              v-model="form.telephone"
              type="telephone"
              id="telephone"
              name="telephone"
              class="w-full px-3 py-2 bg-transparent outline-none rounded-lg bg-white border-none"
            />
          </div>
          <div v-if="formConfig.enableAge" class="col-span-4">
            <label for="telephone" class="font-medium"
              >Leeftijd <span class="text-los-pink-dark">*</span></label
            >
            <input
              v-model="form.age"
              type="age"
              id="age"
              placeholder="Bijv. 10"
              name="age"
              class="w-full px-3 py-2 bg-transparent outline-none rounded-lg bg-white border-none"
            />
          </div>
          <div class="col-span-8 sm:col-span-4">
            <label for="postal_code" class="font-medium"
              >Postcode <span class="text-los-pink-dark">*</span></label
            >
            <input
              v-model="form.postal_code"
              type="text"
              id="postal_code"
              name="postal_code"
              class="w-full px-3 py-2 bg-transparent outline-none rounded-lg bg-white border-none"
            />
          </div>
          <div class="col-span-4 sm:col-span-2">
            <label for="postal_code" class="font-medium"
              ><span class="md:hidden">Huisnr. </span
              ><span class="hidden md:inline">Huisnummer </span>
              <span class="text-los-pink-dark">*</span></label
            >
            <input
              v-model="form.house_number"
              type="text"
              id="house_number"
              name="house_number"
              class="w-full px-3 py-2 bg-transparent outline-none rounded-lg bg-white border-none"
            />
          </div>
          <div class="col-span-4 sm:col-span-2">
            <label for="postal_code" class="font-medium"
              ><span class="md:hidden">Toev. </span
              ><span class="hidden md:inline">Toevoeging </span></label
            >
            <input
              v-model="form.addition"
              type="text"
              id="addition"
              name="addition"
              class="w-full px-3 py-2 bg-transparent outline-none rounded-lg bg-white border-none"
            />
          </div>
          <div v-if="formConfig.enableMachine" class="col-span-8">
            <label for="machine" class="font-medium"
              >Machine (merk & type )</label
            >
            <input
              v-model="form.machine"
              type="text"
              id="machine"
              name="machine"
              class="w-full px-3 py-2 bg-transparent outline-none rounded-lg bg-white border-none"
            />
          </div>
          <div class="col-span-8 mt-1">
            <input
              class="mr-2 size-5 rounded mb-1 text-los-blue-darkest bg-gray-100 border-gray-300 focus:ring-los-blue-base focus:ring-2 accent-los-blue-darkest"
              type="checkbox"
              id="terms"
              name="terms"
              v-model="form.terms"
            />
            <label for="terms" class="font-medium"
              >Ik heb de annuleringsvoorwaarden gelezen en ga daarmee akkoord.
            </label>
            <a
              class="font-semibold text-los-blue-darkest underline"
              href="/annuleringsbeleid"
              target="_blank"
              >Lees hier onze annuleringsvoorwaarden</a
            >.
          </div>

          <div class="col-span-full flex items-center justify-end gap-x-6 mt-6">
            <div class="text-los-pink-darkest">
              {{ validationErrorMessage }}
            </div>

            <button
              type="submit"
              class="btn-blue"
              :class="{ disabled: loading }"
              :disabled="loading"
            >
              <span v-if="!loading">Schrijf mij in</span>
              <span v-else>Bezig...</span>
            </button>
          </div>
        </form>

        <p class="md:text-lg lg:text-xl" v-else>
          Deze training is helaas al
          <span class="underline font-bold text-los-pink-darkest">vol</span>. We
          zien je graag tijdens een van de andere beschikbare trainingen.
        </p>
      </div>
    </div>

    <div v-if="finishedForm" class="px-1 py-2 lg:py-4 lg:px-16">
      <p class="text-3xl lg:text-5xl text-los-blue-darkest">
        <strong>Naais!</strong>
      </p>
      <p class="text-basic mt-3">
        De inschrijving is gelukt!<br />We sturen je een bevestiging en nemen
        spoedig contact met je op.
      </p>
      <button
        v-if="canApply"
        @click="finishedForm = false"
        class="btn-blue mt-8"
      >
        Nog iemand aanmelden?
      </button>
    </div>
  </div>
</template>

<script setup>
const { create } = useStrapi();

const toastsStore = useToastsStore();
const finishedForm = ref(false);

const props = defineProps({
  workshop: {
    type: Object,
    required: true,
  },
  typeName: {
    type: String,
    required: true,
  },
  showCol: {
    type: Boolean,
    default: false,
  },
  formConfig: {
    type: Object,
    default: null,
  },
});

const emit = defineEmits(['onApply']);

const defaultFormValues = {
  firstname: '',
  lastname: '',
  email: '',
  repeat: '',
  telephone: '',
  postal_code: '',
  house_number: '',
  addition: '',
  machine: props.formConfig.enableMachine ? '' : 'n.v.t.',
  age: props.formConfig.enableAge ? '' : 'n.v.t.',
  terms: false,
};

const form = ref({ ...defaultFormValues });
const validationErrorMessage = ref('');
const loading = ref(false);

const dates = computed(() => {
  return [
    {
      start_date_time: props.workshop.start_date_time,
      end_date_time: props.workshop.end_date_time,
      id: 0,
    },
    ...props.workshop.extra_dates,
  ];
});

const canApply = computed(() => {
  return props.workshop.spots - (props.workshop.participants?.length ?? 0);
});

function validateForm() {
  const foundFalsyField = Object.entries(form.value).findIndex(
    ([key, value]) => {
      return !['machine', 'addition'].includes(key) && !value;
    }
  );

  if (foundFalsyField !== -1) {
    validationErrorMessage.value =
      'Nog niet alle velden zijn correct ingevuld.';
    return false;
  }

  if (form.value.email !== form.value.repeat) {
    validationErrorMessage.value = 'Het emailadres komt niet overeen.';
    return false;
  }

  return true;
}

function resetFormValues() {
  form.value = { ...defaultFormValues };
}

async function onSubmitForm() {
  if (!validateForm()) {
    return;
  }

  form.value.number = Number(form.value.number);

  try {
    loading.value = true;
    await create('workshop-participants', {
      ...form.value,
      workshop: props.workshop.id,
    });

    emit('onApply', props.workshop.id);
    finishedForm.value = true;
    resetFormValues();
    setTimeout(() => {
      const element = document.getElementById('inschrijf-formulier');
      element?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest',
      });
    }, 1);
  } catch (err) {
    toastsStore.setFailedToast({
      title: 'Oeps! Er ging iets verkeerd.',
    });
  } finally {
    loading.value = false;
  }
}
</script>

<style lang="scss" scoped></style>
